import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=698462d6&scoped=true&"
import script from "./PageBuilder.vue?vue&type=script&lang=js&"
export * from "./PageBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PageBuilder.vue?vue&type=style&index=0&id=698462d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698462d6",
  null
  
)

export default component.exports